import React, { useEffect } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useTenent } from "../contexts/TenentContext";

const Login = () => {
  const { currentUser } = useAuth();
  const { tenentToken } = useTenent();

  useEffect(() => {
    const getUrl = window.location;
    const baseUrl = getUrl.protocol + "//" + getUrl.host;
    console.log(currentUser);
    if (currentUser) {
      window.location.replace(baseUrl);
    }
    console.log(`${baseUrl}/authorize`);
    window.location.replace(
      `http://localhost:5000/api/v1/auth/discord/login?tenent_token=${tenentToken}&redirect_uri=${baseUrl}/authorize`
    );
  }, [currentUser, tenentToken]);

  return <div></div>;
};

export default Login;
